const mEditionBillingMySalesInvoicesHistory = {
  mEditionBillingMySalesInvoicesHistory: {
    alerts: {
      readExportarComprobantes: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de Comprobantes descargado.'
      },
    },

    buttonPrimary: 'Descargar CSV',

    buttonSecondary: {
      filterText: 'Filtros Avanzados'
    },

    files: {
      invoices: 'comprobantes'
    },

    selectSalesMethods: {
      firstOption: 'Todos los Puntos de Venta'
    },

    table: {
      thAmount: 'SUBTOTAL',
      thCountry: 'PAÍS',
      thClient: 'ALUMNO',
      thDate: 'FECHA',
      thDoc: 'DOCUMENTO',
      thNumber: 'NÚMERO',
      thQuotation: 'COTIZACIÓN',
      thRecord: 'VER',
      thTax: '% IVA',
      thTaxAmount: 'IMPUESTO',
      thToTal: 'TOTAL'
    },

    tooltip: {
      restart: 'Actualizar',
      search: 'Buscar'
    }
  }
}

export default mEditionBillingMySalesInvoicesHistory
